import store from "@/store/index";
import router from "@/router/index";
import logo from "@/assets/images/logo.png";
import defaultImg from "@/assets/images/default_img.jpg";
let res = {
  url(extra) {
    let path = route.path;
    let query = Object.assign({}, route.query, extra);
    let sb = "";
    let index = 0;
    for (let key in query) {
      if (query[key]) {
        sb += index == 0 ? "?" : "&";
        sb += key + "=" + query[key];
        index++;
      }
    }
    // console.log('query', route, query, path + sb)
    return path + sb;
  },
  remote(path, w, h, c) {
    if (!path) return defaultImg;
    if (Array.isArray(path)) {
      if (path.length == 0) return path[0];
      path = path[0];
      if (!path) return defaultImg;
    }
    let attach = "";
    if (w) {
      attach += "w" + w;
    }
    if (h) {
      attach += "h" + h;
    }
    if (c) {
      attach += "c" + c;
    }
    if (path.startsWith("http")) {
      return path;
    }
    return store.state.imageServer + "/file/get" + path + (attach ? "!" + attach : "");
  },
};

export default res;
